import { render, staticRenderFns } from "./SignupOptions.vue?vue&type=template&id=6019128a&"
import script from "./SignupOptions.vue?vue&type=script&lang=js&"
export * from "./SignupOptions.vue?vue&type=script&lang=js&"
import style0 from "./SignupOptions.vue?vue&type=style&index=0&id=6019128a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports